import type { WorldScenery, WorldSceneryLayer } from '@/world-prototype/types';

/**
 * Standard scenery stack for a PorchLight yard.
 * Production art plugs in by setting `src` on each layer (or replacing masterArtwork).
 */
export function createYardScenery(options: {
  masterArtwork?: WorldScenery['masterArtwork'];
  landscapeBleedArtwork?: WorldScenery['landscapeBleedArtwork'];
  extras?: readonly WorldSceneryLayer[];
}): WorldScenery {
  const base: WorldSceneryLayer[] = [
    {
      id: 'background',
      kind: 'background',
      zIndex: 0,
      placeholderClass: 'wp-layer-background',
    },
    {
      id: 'ground',
      kind: 'ground',
      zIndex: 10,
      placeholderClass: 'wp-layer-ground',
    },
    {
      id: 'fence',
      kind: 'fence',
      zIndex: 20,
      placeholderClass: 'wp-layer-fence',
    },
    {
      id: 'porch',
      kind: 'porch',
      zIndex: 25,
      placeholderClass: 'wp-layer-porch',
    },
    {
      id: 'trees',
      kind: 'trees',
      zIndex: 30,
      placeholderClass: 'wp-layer-trees',
    },
    {
      id: 'garden',
      kind: 'garden',
      zIndex: 40,
      placeholderClass: 'wp-layer-garden',
    },
    {
      id: 'mailbox',
      kind: 'prop',
      zIndex: 60,
      placeholderClass: 'wp-layer-mailbox',
    },
    {
      id: 'hammock',
      kind: 'prop',
      zIndex: 60,
      placeholderClass: 'wp-layer-hammock',
    },
  ];

  const extras = options.extras ?? [];
  const byId = new Map<string, WorldSceneryLayer>();
  for (const layer of [...base, ...extras]) {
    byId.set(layer.id, layer);
  }

  return {
    masterArtwork: options.masterArtwork,
    landscapeBleedArtwork: options.landscapeBleedArtwork,
    layers: [...byId.values()].sort((a, b) => a.zIndex - b.zIndex),
  };
}
